var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isMdUp
    ? _c(
        "div",
        { style: { flexGrow: 1, height: "100%" } },
        [
          !_vm.$route.params.taskId
            ? _c(
                "w-card",
                { style: { flexGrow: 1, height: "100%" } },
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
                  _c(
                    "w-scroll-view",
                    { staticClass: "grow", attrs: { tag: "w-card-content" } },
                    [_vm._t("default")],
                    2
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { icon: "eye" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleCompleted()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.toggleTasksText) + " ")]
                      ),
                      _c("w-spacer"),
                      _vm.canEdit
                        ? _c(
                            "w-dropdown",
                            {
                              attrs: {
                                icon: "plus",
                                items: _vm.addDropdownItems,
                                up: "",
                                right: "",
                              },
                              on: {
                                click: function ($event) {
                                  return $event()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("common.add")) + " ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _c(
        "app-mobile-full-screen-container",
        [
          _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": "" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c(
                    "w-toolbar-item",
                    { staticClass: "ml", attrs: { to: "/tasks" } },
                    [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                    1
                  ),
                  _c("w-toolbar-text", { staticClass: "app-title" }, [
                    _vm._v(" " + _vm._s(_vm.title) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.toggleCompleted()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "eye" } })],
                1
              ),
              _vm.canEdit
                ? _c(
                    "w-dropdown",
                    {
                      attrs: { items: _vm.addDropdownItems, right: "" },
                      on: {
                        click: function ($event) {
                          return $event()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "w-container",
            [
              !_vm.$route.params.taskId
                ? _c(
                    "w-card",
                    { style: { flexGrow: 1, height: "100%" } },
                    [
                      _c(
                        "w-scroll-view",
                        {
                          staticClass: "grow",
                          attrs: { tag: "w-card-content" },
                        },
                        [_vm._t("default")],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }